import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AdminStoreModule } from './admin/admin-store.module';
import { GeneralStoreModule } from './general/general-store.module';
import { HistoryStoreModule } from './history/history-store.module';
import { ReportStoreModule } from './report/report-store.module';
import { ScreenStoreModule } from './screen/screen-store.module';
import { consultPatientReducer } from '../core/component/consult-patient/store/consult-patient.reducer';
import { CommonStoreModule } from './common/common-store.module';

@NgModule({
  imports: [
    StoreModule.forRoot(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      }
    ),
    AdminStoreModule,
    CommonStoreModule,
    GeneralStoreModule,
    HistoryStoreModule,
    ReportStoreModule,
    ScreenStoreModule,
    StoreModule.forFeature('core', {
      consultPatient: consultPatientReducer,
    }),
  ],
})
export class KhuyanaMainStoreModule {}
